//#region src/lib/constants.js
var DEFAULT_SLOT_NAME = "default";
var VALUE_UPDATE_EVENT = "update:value";
var MEMBER_UPDATE_EVENT = "update:member";
var OPTIONS_UPDATE_EVENT = "update:options";
var SETTINGS_UPDATE_EVENT = "update:settings";
var SETTINGS_THEME_KEY = "dialtoneCombinatorTheme";
var SETTINGS_SIDEBAR_KEY = "dialtoneCombinatorSidebar";
var SETTINGS_SCHEME_KEY = "dialtoneCombinatorCodeScheme";
var SETTINGS_VERBOSE_KEY = "dialtoneCombinatorCodeVerbose";
var SETTINGS_INDENT_KEY = "dialtoneCombinatorCodeIndent";
var SETTINGS_POSITIONING_KEY = "dialtoneCombinatorRendererPositioning";
var SETTINGS_BACKGROUND_KEY = "dialtoneCombinatorRendererBackground";
//#endregion
export { DEFAULT_SLOT_NAME, MEMBER_UPDATE_EVENT, OPTIONS_UPDATE_EVENT, SETTINGS_BACKGROUND_KEY, SETTINGS_INDENT_KEY, SETTINGS_POSITIONING_KEY, SETTINGS_SCHEME_KEY, SETTINGS_SIDEBAR_KEY, SETTINGS_THEME_KEY, SETTINGS_UPDATE_EVENT, SETTINGS_VERBOSE_KEY, VALUE_UPDATE_EVENT };

//# sourceMappingURL=constants.js.map